import query from './query';
import { COLUMNS } from './keys';
import DataTable from '../../../components/Datatable';
import CheckData from '../../../components/CatchError';
import Component from '../../../components/Component';
import { withTranslation } from 'react-i18next';

class GSCReportSubdomains extends Component {
    constructor() {
        super();
        this.query = query;
    }

    searchFunction(data, search) {
        if (!search) return data;
        return data.filter((item) =>
            search ? item.subdomain?.toLowerCase().includes(search.toLowerCase()) : item,
        );
    }

    render() {
        const { t } = this.props;

        const sortFns = {
            subdomain: (array) => array.sort((a, b) => a.subdomain.localeCompare(b.subdomain)),
            traffic_share: (array) =>
                array.sort(
                    (a, b) =>
                        a.clicks / this.props.total_clicks - b.clicks / this.props.total_clicks,
                ),
            urls: (array) => array.sort((a, b) => a.urls - b.urls),
            clicks: (array) => array.sort((a, b) => a.clicks - b.clicks),
            keywords: (array) => array.sort((a, b) => a.keywords - b.keywords),
            impressions: (array) => array.sort((a, b) => a.impressions - b.impressions),
            position: (array) => array.sort((a, b) => a.position - b.position),
            ctr: (array) => array.sort((a, b) => a.ctr - b.ctr),
        };

        return (
            <>
                <CheckData
                    content_id={this.props.content_id}
                    parent_id={this.props.parent_id}
                    data={this.state.data}
                    loading={this.state.loading}
                >
                    <DataTable
                        nodes={this.state.data}
                        sortFns={sortFns}
                        COLUMNS={COLUMNS(this.props.total_clicks, t)}
                        uniqKey={'subdomain'}
                        fileName={t('search.header')}
                        header={t('search.header')}
                        forceRun={this.forceRun}
                        defaultSortKey="clicks"
                        searchFunction={this.searchFunction}
                        additionalStyles={{
                            Table: `
                                --data-table-library_grid-template-columns : minmax(200px, 2fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) minmax(120px, 1fr) !important;
                            `,
                            BaseCell: `  font-family: 'Raleway';
                                        font-weight: 500;
                                        font-size: 16px;
                                        line-height: 19px;
                                        padding: 16px 10px !important;
                                        color: #0D182C;
                                    
                                    
                                        &.underline {
                                            text-decoration: underline;
                                        }
                                        `,
                        }}
                    />
                </CheckData>
            </>
        );
    }
}

export default withTranslation()(GSCReportSubdomains);
